import React, { useState } from 'react';
import { DialogIE } from '@naf/dialog';
import { Button } from '@naf-simba/elements-buttons';

const IEDialog = () => {
  const [open, setOpen] = useState(true);
  return (
    <DialogIE
      isOpen={open}
      handleClose={() => setOpen(false)}
      button={<Button onClick={() => setOpen(false)}>Ok</Button>}
    >
      Vi støtter ikke Internet Explorer. Bytt til en mer moderne nettleser som Chrome, Firefox, Safari, Opera eller Edge
      for å få en god og sikker opplevelse av nettsidene våre.
    </DialogIE>
  );
};

export default IEDialog;
